import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

const GlobalStyles = () => {
  return (
    <MuiGlobalStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          width: '100%',
          height: '100%',
          '-ms-text-size-adjust': '100%',
          '-webkit-overflow-scrolling': 'touch'
        },
        body: {
          width: '100%',
          height: '100%'
        },
        '#root': {
          width: '100%',
          height: '100%'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
            '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
          }
        },
        textarea: {
          '&::-webkit-input-placeholder': { color: '#919EAB' },
          '&::-moz-placeholder': { opacity: 1, color: '#919EAB' },
          '&:-ms-input-placeholder': { color: '#919EAB' },
          '&::placeholder': { color: '#919EAB' }
        },
        a: { color: '#00AB55' },
        img: { display: 'block', maxWidth: '100%' }
      }}
    />
  );
};

export default GlobalStyles;
